import React from 'react';
import Login from './Login';
import Signup from './Signup';
import Homepage from './Homepage';
import Mainproject from './Mainproject'
import Service from './Service'
import Shop from './Shop'
import About from './About'
import Contact from './Contact'
import { BrowserRouter, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <BrowserRouter>
      <Routes>
      <Route path="/"element={<Homepage/>} />
        <Route path='/Signup' element={<Signup/>}></Route>
        <Route path='/login' element={<Login/>}></Route>
        <Route path='/Mainproject' element={<Mainproject/>}></Route>
        <Route path='/Service' element={<Service/>}></Route>
        <Route path='/Shop' element={<Shop/>}></Route>
        <Route path='/About' element={<About/>}></Route>
        <Route path='/Contact' element={<Contact/>}></Route>
      </Routes>
    </BrowserRouter>

    
  );
}
export default App;
